import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { collection, query, where, onSnapshot, getDocs } from 'firebase/firestore';
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Badge, useMediaQuery, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import Iconify from '../../components/Iconify';
import { db } from '../../firebase';

import { useUser } from '../../UserContext';



// import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Mobile fix
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const { user } = useUser(); // or currentUser if that's your naming
  const navigate = useNavigate();
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (!user?.uid) return;

    const convRef = collection(db, 'conversations');
    const convQuery = query(convRef, where('participants', 'array-contains', user.uid));

    const unsubscribe = onSnapshot(convQuery, async (convSnapshot) => {
      let totalUnread = 0;

      // For each conversation, do a sub-query for unread messages
      await Promise.all(
        convSnapshot.docs.map(async (convDoc) => {
          const convId = convDoc.id;
          const msgRef = collection(db, `conversations/${convId}/messages`);
          const unreadQuery = query(
            msgRef,
            where('recipientId', '==', user.uid),
            where('read', '==', false)
          );
          const unreadSnap = await getDocs(unreadQuery);
          totalUnread += unreadSnap.size;
        })
      );

      setUnreadMessagesCount(totalUnread);
    });

    return () => unsubscribe();
  }, [user]);



  return (
    <RootStyle>
      <ToolbarStyle>
        <IconButton
          onClick={onOpenSidebar}
          sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        {/* Show title only on mobile view */}
        {isMobile && (
          <Typography variant="h6" noWrap sx={{ color: 'text.primary' }}>
            Ballarat Squash & Racquetball
          </Typography>
        )}

        {/* If you want a search bar 
        <Searchbar />
        */}

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
        {user?.activeMembership && (
            <IconButton onClick={() => navigate('/dashboard/messages')}>
              <Badge badgeContent={unreadMessagesCount} color="error">
                <EmailIcon />
              </Badge>
            </IconButton>
          )}

          {/* Show notifications only if the user has an active membership */}
          {user?.activeMembership && <NotificationsPopover />}

          {/* 3) Account / Profile */}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
